import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';

import { ruLocale } from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsDatepickerModule } from "ngx-bootstrap";
import { ToastrModule } from 'ngx-toastr';
import { BsDropdownModule, ModalModule } from 'ngx-bootstrap';
import { AuthenticationGuard } from "app/services/authentication-guard.service";
import { LightboxModule } from 'angular2-lightbox';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { AccountModule } from 'app/account/account.module'
import { ClientModule } from "app/client/client.module";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    RouterModule,
    AccountModule,
    ClientModule,
    LightboxModule,
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    ToastrModule.forRoot(),
    AppRoutingModule
  ],
  providers: [
    AuthenticationGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    defineLocale('ru', ruLocale);
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/app.module.ts